import {TimelineMax, TweenMax, Linear, Elastic} from 'gsap'
let screen, tabletW, tabletH, slides

const runHappy = () => {
	const el = document.querySelectorAll('.happy div div')
	let width = 0
	el.forEach(e => width += e.clientWidth)
	
	TweenMax.fromTo('.video', 1,
		{opacity: 0},
		{opacity: 1})
	TweenMax.fromTo('.happy', 15,
		{x: 0},
		{x: -width/2, repeat: -1, ease: Linear.easeNone})
	TweenMax.fromTo('.video-after', 10,
		{backgroundColor: 'rgba(214, 64, 45, 0.8)'},
		{backgroundColor: 'rgba(50, 71, 116, 0.8)', repeat: -1, yoyo: true, ease: Linear.easeNone})
}

const showLogo = () => {
	let w = screen.H
	let logotopW = tabletW/3
	let logotop = screen.H/2 - tabletH/2 - tabletW/3*62/202*1.5
	if (screen.isPortrait) {
		w = screen.W
		logotopW = tabletW/2
		logotop = screen.H/2 - tabletH/2 - tabletW/2*62/202*2.2
	}
	const tm = new TimelineMax()
	tm.pause()
	// 202x62
	tm.set(`.logotop`, {css:{
		width: logotopW, 
		x: screen.W/2 - tabletW/2, 
		y: logotop
	}})
	tm.set(`.logo`, {css:{width: `${w}px`, height: `${w}px`, y: `${screen.H/2 - w/2}px`, x: `${screen.W/2 - w/2}px`}})
	tm.add(TweenMax.fromTo(`.logo`, 2, 
		{scale: 0},
		{scale: 1
		}))
	tm.add(TweenMax.fromTo(`.logo`, 2, 
		{scale: 1, rotationY: 0, y: screen.H/2 - w/2, x: screen.W/2 - w/2},
		{scale: 0.3, rotationY: 360, y: 0, x: -w/3,
			
		}), 3)
	tm.add(TweenMax.fromTo(`.logotop`, 2, 
		{opacity: 0},
		{opacity: 1}), 5)

	tm.add(TweenMax.fromTo('.tablet', 2, 
		{opacity: 0, rotationY: -90},
		{opacity: 1, rotationY: 0, ease: Elastic.easeOut,
		onComplete: () => {runSlide(0)}
		}), 4)
	tm.add(TweenMax.fromTo(['.tablet', '.tablet-slide.slide-0'], 2, 
		{opacity: 0},
		{opacity: 1, }), 4)
	tm.play()
	
}

const runSlide = (slide) => {
	const sh = tabletW * slides[slide].h / slides[slide].w
	const h = tabletH

	TweenMax.fromTo(`.tablet-slide.slide-${slide}`, slides[slide].h / 1000, 
		{x: 0, y: 0},
		{x: 0, y: h-sh, 
		onComplete: () => {
			let newSlide = slide + 1
			if (newSlide>=slides.length) newSlide = 0
			if (slides[newSlide].type==='page') {
				changeSlide(slide, newSlide)
			} else {
				slideDetail(slide, newSlide)
			}
		}})
	}
const changeSlide = (slide, newSlide) => {
	const tm = new TimelineMax()
	tm.pause()
	tm.set(`.tablet-slide.slide-${slide}`, {css:{zIndex:1}})
	tm.set(`.tablet-slide.slide-${newSlide}`, {css:{zIndex:2, opacity:1, y:0}})
	tm.add(TweenMax.fromTo(`.tablet-slide.slide-${newSlide}`, 2, 
		{x: tabletW},
		{x: 0, ease: Elastic.easeOut.config(1, 0.3),
			onComplete: () => {
				runSlide(newSlide)
			}
		}))
	tm.add(TweenMax.fromTo(`.tablet-slide.slide-${slide}`, 1, 
		{x: 0, opacity:1},
		{x: 0, opacity:0}),
		3)
	tm.play()
}
const slideDetail = (slide, newSlide) => {
		const w = tabletH * slides[newSlide].w / slides[newSlide].h
		const tm = new TimelineMax()
		tm.pause()
		tm.set(`.tablet-slide.slide-${slide}`, {css:{zIndex:1}})
		tm.set(`.tablet-slide.slide-${newSlide}`, {css:{zIndex:2, opacity:1, y:0, width: `${w}px`, x: tabletW}})
		if (slides[newSlide].pause) {
			tm.add(TweenMax.fromTo(`.tablet-slide.slide-${newSlide}`, 3, 
				{x: tabletW},
				{x: -(w-tabletW)/2
			}))
			tm.add(TweenMax.fromTo(`.tablet-slide.slide-${newSlide}`, 2, 
				{x: -(w-tabletW)/2},
				{x: -w,
				onComplete: () => {
					tm.set(`.tablet-slide.slide-${newSlide}`, {css:{zIndex:1, opacity:0, y:0, width: `${w}px`, x: tabletW}})
					let nnewSlide = newSlide + 1
					if (nnewSlide>=slides.length) nnewSlide = 0
					if (slides[nnewSlide].type==='page') {
						changeSlide(slide, nnewSlide)
					} else {
						slideDetail(slide, nnewSlide)
					}
				}
			}), 5)
		} else {
			tm.add(TweenMax.fromTo(`.tablet-slide.slide-${newSlide}`, 5, 
				{x: tabletW},
				{x: -w,
				onComplete: () => {
					tm.set(`.tablet-slide.slide-${newSlide}`, {css:{zIndex:1, opacity:0, y:0, width: `${w}px`, x: tabletW}})
					let nnewSlide = newSlide + 1
					if (nnewSlide>=slides.length) nnewSlide = 0
					if (slides[nnewSlide].type==='page') {
						changeSlide(slide, nnewSlide)
					} else {
						slideDetail(slide, nnewSlide)
					}
				}
			}))
		}
		tm.play()
	}

const animation = {
	run: (state, sslides) => {
		slides = sslides
		screen = state.screen
		tabletW = state.tabletW
		tabletH = state.tabletH
		runHappy()
		showLogo()
	}
}

export default animation



// WEBPACK FOOTER //
// ./src/animation.js